<h1 mat-dialog-title>Timesheet Information</h1>

<mat-dialog-content>
  <p>Daily and weekly total boxes contain all records for an employee, across any timesheet.</p>
  <p>White input boxes (i.e., ST, OT, DT) only contain records created by you for this timesheet.</p>
  <ul class="list-inside list-disc pl-8">
    <li>
      <strong>Timesheet Creator: </strong> <span notranslate>{{ datahub.userService.getEmployeeNumber() }}</span>
    </li>
    <li>
      <strong>Creator's Name: </strong> <span notranslate>{{ datahub.userService.getName() }}</span>
    </li>
    <li>
      <strong>Week Ending Date: </strong> <span notranslate>{{ weekending }}</span>
    </li>
    <li>
      <strong>Service Order: </strong> <span notranslate>{{ datahub.contract.value.ServiceOrder }}</span>
    </li>
  </ul>
</mat-dialog-content>
